import * as React from 'react'
import {
  async_saveFormData,
  incrementCTAClickCount,
  setFormDataObj,
} from '../../redux/actions/lottery'
import WheelAnalyticsManager from '../../analytics/WheelAnalyticsManager'
import Form from '@rjsf/core'
import { useDispatch, useSelector } from 'react-redux'
import WheelButton from '../../components/cta/WheelButton'
import { tt } from '../../i18n'
import './styles.scss'
import { FunctionComponent } from 'react'
import { lotteryStepSelector } from '../../redux/selectors/lottery'

const CustomCheckbox = function (props: any) {
  return (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        checked={props.value}
        id={props.id}
        onChange={() => props.onChange(!props.value)}
        required={props.required}
      />
      <label className="form-check-label" htmlFor={props.id}>
        {props.label}
      </label>
    </div>
  )
}

const widgets = {
  CheckboxWidget: CustomCheckbox,
}

interface Props {}

const CustomFormModalContent: FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch()

  const step = useSelector(lotteryStepSelector)

  const onSubmit = async (
    e: any,
    nativeEvent: React.FormEvent<HTMLFormElement>
  ) => {
    if (nativeEvent && nativeEvent.preventDefault) {
      nativeEvent.preventDefault()
    }

    WheelAnalyticsManager.logEvent('custom_form_submit')
    dispatch(setFormDataObj(e.formData))
    dispatch(async_saveFormData())
    dispatch(incrementCTAClickCount())
  }

  if (!step) return null

  if (!step.tag || !step.tag2) {
    return null
  }

  const schema = JSON.parse(step.tag)
  const uiSchema = JSON.parse(step.tag2)

  return (
    <>
      <h1>{step.customLinkTitle || tt('poll_title')}</h1>

      <Form
        schema={schema}
        uiSchema={uiSchema}
        widgets={widgets}
        onSubmit={onSubmit}
      >
        <WheelButton isSubmit={true} text={tt('play')} />
      </Form>
    </>
  )
}

export default CustomFormModalContent
